import { API_BASE_URL} from "../baseURL";

const AddFarmerModal = ({ setFarmers, setShowAddModal }) => {
    function create() {
        fetch(`${API_BASE_URL}/farmers/create-farmer`, {
            method: "POST",
            headers: {
                "content-type": "application/json",
                "Authorization": "Bearer " + localStorage.getItem('token')
            },
            body: JSON.stringify(
                {
                        farmerId:   0,
                        firstName:  document.getElementById("firstname").value,
                        surname:    document.getElementById("surname").value,
                        email:      document.getElementById("email").value,
                        land:       document.getElementById("land").value,
                        plz:        document.getElementById("plz").value,
                        location:   document.getElementById("location").value,
                        address:    document.getElementById("address").value,
                        festnetz:   document.getElementById("festnetz").value,
                        handy:      document.getElementById("handy").value,
                        comment:    document.getElementById("comment").value
                    }
               )
        }).then(response => response.json())
            .then(data => setFarmers(data))
    }

    return (
        <>
            <div className="custom-modal">
                <div className="custom-modal-dialog">
                    <div>
                        <button onClick={() => setShowAddModal(false)} style={{ float: "right" }}> &times; </button>
                        <h4> Neuer Landwirt </h4>
                    </div>

                    <br/>

                    <table>
                        <tbody>
                            <tr>
                                <td style={{width: "20%"}}><b> Nachname </b></td>
                                <td><input type="text" id="surname"></input></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> Vorname </b></td>
                                <td><input type="text" id="firstname"></input></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> E-mail </b></td>
                                <td><input type="text" id="email"></input></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> Land </b></td>
                                <td><input type="text" id="land"></input></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> PLZ </b></td>
                                <td><input type="text" id="plz"></input></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> Ort </b></td>
                                <td><input type="text" id="location"></input></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> Adresse </b></td>
                                <td><input type="text" id="address"></input></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> Festnetz </b></td>
                                <td><input type="text" id="festnetz"></input></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> Handy </b></td>
                                <td><input type="text" id="handy"></input></td>
                            </tr>

                            <tr>
                                <td style={{width: "20%"}}><b> Kommentar </b></td>
                                <td><input type="text" id="comment"></input></td>
                            </tr>
                        </tbody>
                    </table>

                    <div style={{marginTop: "20px"}}>
                        <button onClick={() => { setShowAddModal(false); }} className="custom-btn-close" > Schließen </button>
                        <button
                            onClick={() => {
                                setShowAddModal(false)
                                create()
                                }
                            }
                            className="custom-btn-save"> Speichern </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddFarmerModal;
